import { render } from "./regiser.vue?vue&type=template&id=ee62948a"
import script from "./regiser.vue?vue&type=script&lang=js"
export * from "./regiser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__